<template>
  <el-container class="hotellist-main" id="main">
    <publicHeader @setCollapse="setCollapse" @getPermissions="getPermissions"></publicHeader>
    <div class="main-content">
      <publicMenu :isCollapse="isCollapse" :allPermissions="allPermissions"></publicMenu>
      <div class="content">
        <slot>
          <el-main>
            <div class="main" >
              <!--详情页 开始-->
              <div class="list-content">
                <!-- <div class="back-button">
                  <img src="/static/img/order/u763.png" class="back-img">
                  <span style="color: #005126;">back</span>
                </div> -->
                <!-- <OrderTop :hotelOut="hotel" :orderDataOut="orderData" :source="source" :paymentOn="paymentOn"></OrderTop> -->
                <el-skeleton animated :loading="orderShow">
                  <template slot="template">
                    <div class="hotel-info" style="margin-top: 0px;">
                      <div style="height: 32px; line-height: 32px;">
                        <el-skeleton-item variant="text" style="width: 40%; height: 30px;" />
                      </div>
                      <div style="font-size: 12px; margin-top: 5px;margin-bottom: 15px;"><el-skeleton-item variant="text" style="width: 50%;" /></div>
                      <div style="border-bottom: 1px solid rgba(83, 102, 163, 1); border-width: 1px;"></div>
                      <div class="order-info">
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info"><el-skeleton-item variant="text" style="width: 60%;" /></span>
                          <span class="right-info"><el-skeleton-item variant="text" style="width: 20%;" /></span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template>
                    <div class="hotel-info" style="margin-top: 0px;">
                      <div style="height: 32px; line-height: 32px;">
                        <span style="font-size: 28px; font-weight: 650; color: rgba(83, 102, 163, 1);">{{hotel.hotelname_en}}</span>
                        <span style="font-size: 12px; margin-left: 40px; font-weight: 500;">
                          <b style="margin-right: 3px;" v-for="val in hotel.hotelscore" :key="val">
                            <img style="width:15px;height:15px; margin-bottom: 3px;" src="/static/img/star.png">
                          </b>
                          <b style="margin-left: -3px;" v-if="hotel.star_decimal === 1">
                            <img style="width:15px;height:15px; margin-bottom: 3px;" src="/static/img/star-decimal.png">
                          </b>
                        </span>
                      </div>
                      <div style="font-size: 12px; margin-top: 5px;margin-bottom: 15px;">{{hotel.hoteladdress_en}}</div>
                      <div style="border-bottom: 1px solid rgba(83, 102, 163, 1); border-width: 1px;"></div>
                      <div class="order-info">
                        <div class="oneline">
                          <span class="left-info">Room type</span>
                          <span class="right-info">{{orderData.roomName.en}}<a href="javascript:;" @click="showFacilities(orderData)" style="text-align: left; margin-left: 10px;">Facilities & Amenities</a></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info">Night</span>
                          <span class="right-info">{{orderData.nightCount}}</span>
                        </div>
                        <div class="oneline">
                          <span class="left-info">Room</span>
                          <span class="right-info">{{orderData.roomNum.en}}</span>
                        </div>
                        <div class="oneline">
                          <span class="left-info">Guest</span>
                          <span class="right-info">{{orderData.person.en}}<a v-if="orderData.child.en !== ''">, {{orderData.child.en}}</a></span>
                        </div>
                        <div class="oneline">
                          <span class="left-info">Bed type</span>
                          <span class="right-info">{{orderData.bedGroups[0].description}}</span>
                        </div>
                        <div class="oneline">
                          <span class="left-info">Check-in</span>
                          <span class="right-info">{{orderData.checkin.en}}</span>
                        </div>
                        <div class="oneline">
                          <span class="left-info">Check-out</span>
                          <span class="right-info">{{orderData.checkout.en}}</span>
                        </div>
                        <div class="oneline">
                          <span class="left-info">Breakfast</span>
                          <span class="right-info" :class="{'green-text': orderData.breakfast.en === 'Free breakfast'}">{{orderData.breakfast.en}}</span>
                        </div>
                        <div class="oneline">
                          <span class="left-info">Cancellation policy</span>
                          <!-- <span class="right-info" :class="{'green-text': orderData.canceltext.en !== 'Non-refundable', 'orange-text': orderData.canceltext.en === 'Non-refundable'}">{{orderData.canceltext.en}}</span> -->
                          <el-popover
                            placement="left"
                            width="350"
                            trigger="hover"
                            popper-class="nonFefundable"
                          >
                          <div class="cancel-policy">
                            <div class="title">Cancellation Policy</div>
                            <div class="content-wrapper">
                              <div v-for="(item, i) in orderData.cancelPenalties.list" :key="i" class="content-item">
                                <span class="circle" :style="{ border: '2px solid ' + setCancellationColor(item.type) }"></span>
                                <div class="text-content">
                                  <div class="subtitle">{{ item.title }}</div>
                                  <div class="description">{{ item.desc }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <span slot="reference" style="font-size: 14px;cursor:pointer;" :style="{ color: setCancellationColor(orderData.cancelPenalties.cancellation.type)}">{{orderData.cancelPenalties.cancellation.title}}</span>
                          </el-popover>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-skeleton>
                <form>
                  <!-- 客户信息 开始-->
                  <div class="hotel-info" style=" padding: 10px 1.5% 20px 1.5%;">
                    <div class="hotel-line" v-for="(value, id) in customInfo" :key="id">
                      <div class="hotel-name" style="font-weight: 650;">Room {{id + 1}}</div>
                      <div style="margin-bottom:10px;">
                        <div class="msg-username">
                          <div for="name" class="msg-name">{{$t('firstName')}}</div>
                          <div class="el-form-item__content">
                            <div class="el-input"><input type="text" class="el-input__inner" :value="value.firstname" disabled></div>
                          </div>
                        </div>
                        <div class="msg-username" style="margin: 0 4.5%;">
                          <div for="name" class="msg-name">{{$t('lastName')}}</div>
                          <div class="el-form-item__content">
                            <div class="el-input"><input type="text" class="el-input__inner" :value="value.lastname" disabled></div>
                          </div>
                        </div>
                        <div class="msg-username">
                          <div for="name" class="msg-name">{{$t('nationality')}}</div>
                          <div class="el-form-item__content">
                            <div class="el-input">
                              <el-select style="width:100%;" v-model="value.nationality" filterable disabled>
                                <el-option v-for="item in telOptions" :key="item.id" :label="item.country" :value="item.id">{{item.country}}</el-option>
                              </el-select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 邮箱和电话 -->
                    <div class="hotel-line" style="margin-top: 20px;">
                      <div class="msg-username">
                        <div for="name" class="msg-name">{{$t('emailAddr')}}</div>
                        <div class="el-form-item__content">
                          <div class="el-input"><input type="text" class="el-input__inner" :value="customInfo[0].email" disabled></div>
                        </div>
                      </div>
                      <div class="msg-username" style="margin: 0 4.5%;">
                        <div for="name" class="msg-name">{{$t('phoneNumber')}}</div>
                        <div class="el-form-item__content">
                          <div class="el-input input-bor">
                            <el-select style="width:25%;" v-model="customInfo[0].areaCode" :placeholder="$t('pleaseSelect')" disabled>
                              <el-option v-for="item in telOptions" :label="item.telnum" :key="item.id" :value="item.id">{{item.value}}</el-option>
                            </el-select>
                            <input style="width:73%;float: right;" type="text" class="el-input__inner" :value="customInfo[0].phoneNum" disabled>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 客户信息 结束-->
                  <!-- price details 开始-->
                  <div class="hotel-info">
                    <div class="price-details-header">
                      <span class="hotel-name" style="font-weight: 650;">Price details</span>
                      <span class="package-tag" v-if="orderData.isPkg == 1">Package</span>
                    </div>
                    <div class="price-sections-container">
                      <!-- Pay today section -->
                      <div class="price-section">
                        <div class="section-title">Pay today</div>
                        <div class="price-list">
                          <div class="price-box">
                            <div class="price-item">
                              <span>{{orderData.roomCount}} room<span v-if="orderData.roomCount !=='1' && orderData.roomCount !==1">s</span> × {{orderData.nightCount}} night<span v-if="orderData.nightCount !=='1' && orderData.nightCount !==1">s</span></span>
                              <span>{{orderData.fareTotal}}</span>
                            </div>
                            <div class="price-item">
                              <span>Taxes & fees
                                <el-tooltip
                                content="The taxes are tax recovery charges paid to vendors (e.g., hotels); for details, please see our Terms of Use . Service fees are retained as compensation in servicing your booking and may include fees charged by vendors."
                                placement="top"
                                effect="light"
                                >
                                <span style="cursor: pointer;color: #000000D9;margin-left: 6px;">ⓘ</span>
                              </el-tooltip>
                              </span>
                              <span>{{orderData.tax}}</span>
                            </div>
                            <div v-if="orderData[paymentOn].pTFee > 0" class="price-item">
                              <span>Transaction fee</span>
                              <span>{{orderData.currentCurrency.curMark}}{{orderData.currentCurrency.pTFee[paymentOn]}}</span>
                            </div>
                            <div v-if="isDiscount === true" class="price-item green-text">
                              <span>Coupon</span>
                              <span>
                                {{orderData.discountCode}}
                              </span>
                            </div>
                          </div>

                          <div class="divider"></div>
                          <div class="price-item total">
                            <span>Total</span>
                            <span v-if="isDiscount === false">{{orderData.currentCurrency.curMark}}{{orderData.currentCurrency.payPrice[paymentOn]}}</span>
                            <span v-else>{{orderData.disCurrentCurrency.curMark}}{{orderData.disCurrentCurrency.payPrice[paymentOn]}}</span>
                          </div>
                        </div>
                      </div>

                      <!-- Due at property section -->
                      <div class="price-section" v-if="orderData.payAtProperty !== ''">
                        <div class="section-title">Due at property</div>
                        <div class="price-list">
                          <div class="price-box">
                            <div class="price-item" v-if="orderData.mandatoryFee !== ''">
                              <span>{{$t('mandatoryFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.mandatoryFee}}</span>
                            </div>
                            <div class="price-item" v-if="orderData.mandatoryTax !== ''">
                              <span>{{$t('mandatoryTax')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.mandatoryTax}}</span>
                            </div>
                            <div class="price-item" v-if="orderData.resortFee !== ''">
                              <span>{{$t('resortFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.resortFee}}</span>
                            </div>
                            <div class="price-item" v-if="orderData.cityFee !== ''">
                              <span>{{$t('cityTaxFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.cityFee}}</span>
                            </div>
                            <div class="price-item" v-if="orderData.destinationFee !== ''">
                              <span>{{$t('destinationFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.destinationFee}}</span>
                            </div>
                            <div class="price-item" v-if="orderData.serviceFee !== ''">
                              <span>{{$t('serviceFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.serviceFee}}</span>
                            </div>
                            <div class="price-item" v-if="orderData.CleaningFee !== ''">
                              <span>{{$t('cleaningFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.CleaningFee}}</span>
                            </div>
                            <div class="price-item" v-if="orderData.administrativeFee !== ''">
                              <span>{{$t('administrativeFee')}}<a class="avgprice"> ({{$t('payableAtProperty')}})</a></span>
                              <span>{{orderData.administrativeFee}}</span>
                            </div>
                          </div>
                          <div class="divider"></div>
                          <div class="price-item total">
                            <span>Total</span>
                            <span>{{orderData.payAtProperty}}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="total-price">
                      <span>Total price</span>
                      <span v-if="isDiscount === false">{{orderData.currentCurrency.curMark}}{{orderData.currentCurrency.totalPrice[paymentOn]}}</span>
                      <span v-else>{{orderData.disCurrentCurrency.curMark}}{{orderData.disCurrentCurrency.totalPrice[paymentOn]}}</span>
                    </div>
                  </div>
                  <!-- price details 结束 -->
                  <!--积分信息模块 开始-->
                  <!-- <div class="hotel-info" style="padding: 10px 1.5%;">
                    <div class="hotel-name" style="font-weight: 650;">{{$t('pointsInformation')}}</div>
                    <div style="border-bottom: 1.5px solid rgba(83, 102, 163, 1);"></div>
                    <div class="order-info" style="width: 940px;margin-top: 10px;">
                      <div class="quarter-row-title">
                        <div class="quarter-col">{{$t('event')}}</div>
                        <div class="quarter-col">{{$t('pointsStr')}}</div>
                        <div class="quarter-col">{{$t('dateTime')}}</div>
                      </div>
                      <div class="quarter-row">
                        <div class="quarter-col">{{$t('confirmed')}}</div>
                        <div class="quarter-col"> {{$t('PendingPoints')}}</div>
                        <div class="quarter-col">-</div>
                      </div>
                      <div class="quarter-row">
                        <div class="quarter-col">{{$t('cancelled')}}</div>
                        <div class="quarter-col"> {{$t('PendingPoints')}}</div>
                        <div class="quarter-col">-</div>
                      </div>
                      <div class="quarter-row">
                        <div class="quarter-col">{{$t('checkin')}}</div>
                        <div class="quarter-col"> {{$t('pointsStr')}}</div>
                        <div class="quarter-col">-</div>
                      </div>
                      <div class="quarter-row">
                        <div class="quarter-col">{{$t('quarterly')}}</div>
                        <div class="quarter-col"> {{$t('pointsStr')}}</div>
                        <div class="quarter-col">-</div>
                      </div>
                      <div class="points-txt">{{$t('pointsTxt')}}</div>
                    </div>
                  </div> -->
                  <!--积分信息模块 结束-->
                  <!-- 支付方式 开始-->
                  <div class="hotel-info" style="padding: 10px 1.5%;" id="paymentTypeTop">
                    <div class="hotel-name" style="font-weight: 650;">Digital payment</div>
                    <div style="border-bottom: 1.5px solid rgba(83, 102, 163, 1);"></div>
                    <div style=" margin-top: 15px; height: 30px; line-height: 30px;">
                      <el-radio v-model="paymentOn" :label="item" :text-color="radioColor" v-for="item in orderData.paymethod" :key="item">
                        <span v-if="item === 'paypal'">
                          <img src="/static/img/order/paypal-noborder.png" style="height: 21px; width: 80px; margin: 3px 0;">
                        </span>
                        <span v-else-if="item === 'credit'">
                          <img src="/static/img/order/balance.png" style="height: 24px; width: 24px; margin: 3px 0;">
                          <div class="payment-text">Credit</div>
                        </span>
                        <span v-else-if="item === 'pingpong'">
                          <img src="/static/img/order/pingpong.png" style="height: 27px; width: 40px; margin: -1px 5px -1px 0;">
                          <div class="payment-text">Pay by Card</div>
                        </span>
                      </el-radio>
                    </div>
                    <!-- 积分 -->
                    <div style="font-size: 12px; height: 40px; line-height: 40px;" v-if="orderData[paymentOn].pTFee > 0">
                      The total amount to be charged is <span class="green-text" v-if="isDiscount === false">{{orderData[paymentOn].curMark}}{{orderData[paymentOn].payPrice}}</span><span class="green-text" v-else>{{orderData[paymentOn].curMark}}{{orderData[paymentOn].disPayPrice}}</span>, including a <span class="green-text" v-if="isDiscount === false">{{orderData[paymentOn].curMark}}{{orderData[paymentOn].pTFee}}</span><span class="green-text" v-else>{{orderData[paymentOn].curMark}}{{orderData[paymentOn].disPTFee}}</span> transaction fee.<span v-if="isDiscount === true"> Used coupon. Amount: {{orderData.discountCode}}.</span>
                    </div>
                    <div style="font-size: 12px; height: 40px; line-height: 40px;" v-else>
                      The total amount to be charged is <span class="green-text" v-if="isDiscount === false">{{orderData[paymentOn].curMark}}{{orderData[paymentOn].payPrice}}</span><span class="green-text" v-else>{{orderData[paymentOn].curMark}}{{orderData[paymentOn].disPayPrice}}</span>.<span v-if="isDiscount === true"> Used coupon. Amount: {{orderData.discountCode}}.</span>
                    </div>
                    <div class="long-margin" style="min-height: 380px;" v-if="paymentOn === 'pingpong'">
                      <div id="creditPayment" style="position: relative; height: 415px; width: 50%;margin-left: 1.5%;">
                        <pp-checkout id="payment-pingpong" style="width: 100%; height: 390px; position: absolute;left: -20px;" :accessToken="pingpongAccessToken" :locale="language"></pp-checkout>
                      </div>
                    </div>
                  </div>
                  <!-- 支付方式 结束 -->
                  <!--特殊要求-->
                  <div class="hotel-info" style="height:135px;padding: 10px 1.5%;">
                    <div class="hotel-name" style="font-weight: 650;">Special request (in English please)</div>
                    <div style="height: 30px; line-height: 30px;">
                      <el-input type="textarea" placeholder="" v-model="special"  ref="specialRequirements"  @input="checkSpecial" maxlength="200" show-word-limit class="el-input__inner specialText"></el-input>
                    </div>
                  </div>
                  <!--订房须知-->
                  <div class="container">
                    <h1>Hotel Policies</h1>
                    <div class="policy-columns">
                      <div class="policy-column">

                        <div class="policy-module" v-if="hotelPolicyData.checkin_begin_time">
                          <h2>Check In</h2>
                          <div>Check in time: {{hotelPolicyData.checkin_begin_time}} - {{hotelPolicyData.checkin_end_time}}</div>
                        </div>

                        <div class="policy-module" v-if="hotelPolicyData.checkout_time_en">
                          <h2>Check out</h2>
                          <div>Check out time: {{hotelPolicyData.checkout_time_en}}</div>
                        </div>

                        <div class="policy-module" v-if="hotelPolicyData.hotel_checkin_instructions_en">
                          <h2>Instructions</h2>
                          <div class="policy-content" v-html="hotelPolicyData.hotel_checkin_instructions_en"></div>
                        </div>

                        <div class="policy-module" v-if="hotelPolicyData.special_instructions_en">
                          <h2>Special Instructions</h2>
                          <div class="policy-content" v-html="hotelPolicyData.special_instructions_en"></div>
                        </div>

                        <div class="policy-module" v-if="hotelPolicyData.fees_mandatory_en">
                          <h2>Fees</h2>
                          <div class="policy-content" v-html="hotelPolicyData.fees_mandatory_en"></div>
                        </div>

                        <div class="policy-module" v-if="hotelPolicyData.other_policies_en">
                          <h2>Policies</h2>
                          <div class="policy-content" v-html="hotelPolicyData.other_policies_en"></div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <!--订房须知-->
                  <div class="hotel-info" style="height:auto;padding: 10px 1.5%;" v-if="orderData.hotelFeesEnText !== ''">
                    <div class="hotel-name" style="font-weight: 650;">{{$t('bookingNotice')}}</div>
                    <div style="padding: 2px 1.5%;">
                      <p style="font-size:14px;" class="hotelFeesText" v-html="orderData.hotelFeesEnText"></p>
                    </div>
                  </div>
                  <!--前往最后一步-->
                  <div style="width: 100%; height: 100px; text-align: center; margin-top: 40px;">
                    <el-button type="button" style="float: none;margin-top: 12.5px;" class="booknow_button" @click="JumpOver">{{$t('goPay')}}</el-button>
                  </div>
                </form>
              </div>
            </div>
            <frameNetwork :frameNetworkDialog="frameNetworkDialog"></frameNetwork>
          </el-main>
        </slot>
        <publicFooter :source="source"></publicFooter>
      </div>
    </div>
    <frameRefresh :frameDialog="frameDialog"></frameRefresh>
    <frameHotelSold :frameHotelSoldDialog="frameHotelSoldDialog" :checkIn="checkIn" :checkOut="checkOut"></frameHotelSold>
    <frameHomeSold :frameHomeSoldDialog="frameHomeSoldDialog"></frameHomeSold>
    <frameRise :frameRiseDialog="frameRiseDialog" :risePrice="risePrice" :curPageData="curPageData" @frameRiseBookingFun="frameRiseBookingFun" @frameRiseBookingBackFun="frameRiseBookingBackFun"></frameRise>
<!--    <frameQuotation :frameQuotationDialog="frameQuotationDialog"></frameQuotation>-->
    <frameLast :frameLastDialog="frameLastDialog" :homeSurplus="homeSurplus"></frameLast>
    <frameRemind :frameRemindDialog="frameRemindDialog" @continueBookingFun="continueBookingFun"></frameRemind>
    <frameToolong :frameToolongDialog="frameToolongDialog"></frameToolong>
    <frameNetwork :frameNetworkDialog="frameNetworkDialog"></frameNetwork>
    <frameNotice :frameNoticeDialog="frameNoticeDialog" @frameNoticeFun="frameNoticeFun"></frameNotice>
    <frameNoticePublic :frameNoticePublicShow="frameNoticePublicShow" :showNotice="frameNoticePublicShowText" @frameNoticePublicFun="frameNoticePublicFun"></frameNoticePublic>
    <publicMask :fullscreenLoading="fullscreenLoading || frameQuotationDialog"></publicMask>
    <framePaymentFail :framePaymentFailDialog="framePaymentFailDialog" @paymentRetryClick="paymentRetryClick"></framePaymentFail>
    <frameChangeRoom :frameChangeRoomDialog="frameChangeRoomDialog" :language="language" :sameRoomInfo="sameRoomInfo" :paymentOn="paymentOn" :curPageData="curPageData" @frameChangeRoomBookingFun="frameChangeRoomBookingFun" @frameChangeRoomBookingBackFun="frameChangeRoomBookingBackFun"></frameChangeRoom>
    <frameChangePriceAndRoom :frameChangePriceAndRoomDialog="frameChangePriceAndRoomDialog" :language="language" :sameRoomInfo="sameRoomInfo" :paymentOn="paymentOn" :curPageData="curPageData" :risePrice="risePrice" @frameChangePriceAndRoomBookingFun="frameChangePriceAndRoomBookingFun" @frameChangePriceAndRoomBookingBackFun="frameChangePriceAndRoomBookingBackFun"></frameChangePriceAndRoom>
    <el-dialog
      title="Facilities & Amenities"
      :visible.sync="facilitiesDialogVisible"
      width="30%"
      custom-class="facilities-dialog"
      >
      <div class="facilities-divider"></div>
      <ul class="facilities-list">
        <li v-for="item in amenities" :key="item.name">
          <span class="arrow-icon">►</span>
          <span>{{ item.name }}</span>
        </li>
        <li v-for="item in promotions" :key="item.id">
          <span class="arrow-icon">►</span>
          <span>{{ item.description }}</span>
        </li>
      </ul>
    </el-dialog>
  </el-container>
  </template>

<script>
import { writePayShow, orderBookVerify, writePayFinishBook, orderPayment, wechatJsPayGetSign } from '@/request/order.js'
import { hotelPolicyNew } from '@/request/hotel.js'
import { signIn } from '@/request/login.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import publicMenu from '@/components/public/publicMenu'
import OrderTop from '@/components/order/module/OrderTop'
import frameRefresh from '@/components/public/frameRefresh'
import frameHotelSold from '@/components/public/frameHotelSold'
import frameHomeSold from '@/components/public/frameHomeSold'
import frameRise from '@/components/public/frameRise'
import frameQuotation from '@/components/public/frameQuotation'
import frameLast from '@/components/public/frameLast'
import frameRemind from '@/components/public/frameRemind'
import frameToolong from '@/components/public/frameToolong'
import frameNetwork from '@/components/public/frameNetwork'
import frameNotice from '@/components/public/frameNotice'
import frameNoticePublic from '@/components/public/frameNoticePublic'
import publicMask from '@/components/public/publicMask'
import framePaymentFail from '@/components/public/framePaymentFail'
import frameChangeRoom from '@/components/public/frameChangeRoom'
import frameChangePriceAndRoom from '@/components/public/frameChangePriceAndRoom'

export default {
  name: 'bookingWriteOrder',
  components: {
    publicFooter,
    publicHeader,
    publicMenu,
    OrderTop,
    frameRefresh,
    frameHotelSold,
    frameHomeSold,
    frameRise,
    frameQuotation,
    frameLast,
    frameRemind,
    frameToolong,
    frameNetwork,
    frameNotice,
    frameNoticePublic,
    publicMask,
    framePaymentFail,
    frameChangeRoom,
    frameChangePriceAndRoom
  },
  data () {
    return {
      curPageData: 'bookingWriteOrder',
      hotelid: 0,
      hotel: {},
      orderData: {'roomName': {'zh': '', 'en': ''}, 'cancel': {'zh': '', 'en': ''}, 'night': {'zh': 1, 'en': 1}, 'roomNum': {'zh': 1, 'en': 1}, 'mandatoryFee': '', 'mandatoryTax': '', 'resortFee': '', 'payAtProperty': '', 'paypal': {'curMark': '', 'payPrice': 0, pTFee: 0}, 'pingpong': {'curMark': '', 'payPrice': 0, pTFee: 0}, 'currentCurrency': {curMark: '', 'pTFee': {'paypal': 0, wechat: 0, limit: 0, pingpong: 0}, 'payPrice': {'paypal': 0, wechat: 0, limit: 0, pingpong: 0}, 'totalPrice': {'paypal': 0, wechat: 0, limit: 0, pingpong: 0}}},
      customInfo: [{'email': ''}],
      remainTime: 300,
      guestRoomNum: 2,
      guestRoomMore: false,
      someArray: [],
      desc: '',
      telOptions: [{id: 1, alue: '法国 +33', telnum: '+33'}, {id: 2, value: '瑞典 +46', telnum: '+46'}, {id: 3, value: '美国 +1', telnum: '+1'}, {id: 4, value: '中国 +0086', telnum: '+0086'}],
      selectTel: '216',
      selectNat: {1: '216'},
      minute: '',
      second: '',
      fullscreenLoading: false,
      promiseTimer: '',
      frameDialog: false, // 弹框1
      frameHotelSoldDialog: false, // 弹框2 中文
      frameHomeSoldDialog: false, // 弹框3
      frameRiseDialog: false, // 弹框4
      frameQuotationDialog: false, // 弹框5
      frameLastDialog: false, // 弹框6
      frameRemindDialog: false, // 弹框7
      frameToolongDialog: false,
      frameNetworkDialog: false,
      frameNoticeDialog: false,
      risePrice: 12.5,
      homeSurplus: 3,
      screenWidth: 0,
      currencyShow: false, // 币种是否显示
      loginStatus: false,
      firstName: '',
      lastName: '',
      userEmail: '',
      cancelData: 0,
      pageRefresh: 0,
      pageVerifyNum: 1,
      pageVerifyTimer: '',
      orderWritePageTime: 300,
      language: this.common.languageSet(this),
      orderno: '',
      guestClicksRetry: 0,
      dateNumComplexStr: '',
      roomNumComplexStr: '',
      ismobile: false,
      taxWidth: 327,
      taxDia: false,
      commissionDia: false,
      taxShowClose: false,
      special: '',
      elementWidth: document.documentElement.clientWidth,
      stepWidth: document.documentElement.clientWidth - 20,
      lineWidth: 98,
      lineOneLeft: 48,
      lineTwoLeft: 196,
      policyDialog: false,
      clauseDialog: false,
      source: this.common.sourceSet(),
      wechatH5Status: '',
      inputCursor: true, // 登录数据
      mobileOverview: false, // 订房须知
      cancelDia: false,
      cancelShowClose: false,
      canceltextZh: '',
      canceltextEn: '',
      mandatoryFeeDetail: false,
      payment: {'total': {'status': '0'}},
      payment_card_show: false,
      paymentOn: 'credit',
      activeName: 'electronicPayment',
      paymentCardno: '0',
      paymentCardnoName: '',
      paymentCardnoEffectivedate: '',
      paymentCardnoValidCVV: '',
      checked: false,
      wechatEject: false,
      wechatShowClose: false,
      weChatImgUrl: '',
      showCancel: '0',
      securityCodeShow: false,
      showCardRemind: false,
      showCardRemindTwo: false,
      userNameError: 'appearsOnTheCard',
      cardNoError: 'validCardNumber',
      effectiveDateError: 'pleaseValidCardExpiry',
      securityCodeError: 'validCVV',
      cardNo: '',
      securityCodeShowTwo: false,
      frameNoticePublicShow: false,
      frameNoticePublicShowText: '',
      isCollapse: this.common.collapseSet(),
      contentWidth: document.body.clientWidth - 74,
      personWidth: (document.body.clientWidth - 74) * 0.2182 - 10,
      radioColor: ' rgba(241, 81, 27, 1)',
      TransactionFeeshow: false,
      allPermissions: {'email': '', 'phone_internal': '', 'phone_external': ''},
      checkIn: '',
      checkOut: '',
      orderShow: true,
      pingpongPayClient: '',
      pingpongAccessToken: '',
      pingpongStatus: '', // pingpong 轮询状
      framePaymentFailDialog: false,
      frameChangeRoomDialog: false, // 价格不变，房型变更弹框
      frameChangePriceAndRoomDialog: false, // 价格变更，房型变更
      sameRoomInfo: '',
      isDiscount: false,
      userCouponId: '',
      hotelPolicyData: {},
      facilitiesDialogVisible: false,
      promotions: [],
      amenities: []
    }
  },
  created () {
    this.source = this.common.sourceSet()
    var source = this.common.sourceSet()
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      source = this.$route.query.source
      var sourceExpires = localStorage.getItem('sourceExpiresAt')
      if (sourceExpires !== '' && sourceExpires !== undefined && sourceExpires !== null) {
        var nowTime = Date.now()
        if (nowTime > sourceExpires) {
          localStorage.removeItem('source')
          localStorage.removeItem('sourceExpiresAt')
        } else {
          // 避免手动干预删除或者修改localStorage
          if (source === '' || source === undefined || source === null) {
            localStorage.removeItem('source')
            localStorage.removeItem('sourceExpiresAt')
          } else {
            this.source = source
            this.common.sourceSet(source)
          }
        }
      }
    }
    if (this.source === '' || this.source === undefined || this.source === null) {
      let locationHref = window.document.location.href
      localStorage.setItem('LoginWebsiteAddress', locationHref)
      this.$router.push({name: 'login'})
    }
    // 页面展示
    this.writePayPageShow()
    var width = document.documentElement.clientWidth
    this.taxWidth = width - 40
    if (this.common.languageSet(this) === 'zh') {
      this.lineWidth = (width - 164) / 2
      this.lineOneLeft = 48
      this.lineTwoLeft = this.lineWidth + 96
    } else {
      this.lineWidth = (width - 260) / 2 + 32 // (屏幕宽度 - 左右两侧间距20 - 步骤宽度80*3)/2 = 剩余横线宽度 + 左右延申宽度*2：(整体宽度80-图标25)/2 = 两侧宽度-11.5*2
      this.lineOneLeft = 64 // (整体宽度80-图标25)/2 = 两侧宽度 + 25 = 左侧+图标宽度 + 缝隙11.5
      this.lineTwoLeft = this.lineOneLeft + this.lineWidth + 48 // 第一条线偏移度 + 第一条线长度 + 缝隙11.5:和中文一致*2 + 图标宽度25
    }

    var time = parseInt(new Date().getTime() / 1000)
    var sessionid = this.common.sessionidGet(this)
    var policyDataJson = {'hotelid': this.hotelid, 'operation': 'hotelPolicyNew', 'time': time, 'sessionid': sessionid}
    var policyData = this.common.encryptionData(policyDataJson, this)
    hotelPolicyNew(policyData).then(res => {
      this.hotelPolicyData = res.data
    })
  },
  mounted () {
    var that = this
    if (this.remainTime > 0) {
      this.minute = Math.floor((this.remainTime / 60) % 60)
      this.second = Math.floor(this.remainTime % 60)
      this.countDowm()
    }

    // 获取屏幕尺寸
    this.screenWidth = document.body.clientWidth
    window.onresize = () => {
      // 屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }

    // 监听点击事件
    document.addEventListener('click', function (e) {
      var cardRemindShow = true
      for (var i = 0; i < e.target.classList.length; i++) {
        if (e.target.classList[i] === 'cardRemindShow') {
          cardRemindShow = false
        }
      }
      if (cardRemindShow) {
        that.showCardRemind = false
        that.showCardRemindTwo = false
      }
    })

    // 如果用户跳转参数中携带了paymentOn参数，则默认使用.
    if (['paypal', 'wechat', 'credit', 'pingpong'].includes(this.$route.query.paymentOn)) {
      this.paymentOn = this.$route.query.paymentOn
    }
    // 跳转到待支付页面，直接调起支付.
    if (this.$route.query.autoPay === 1 || this.$route.query.autoPay === '1') {
      this.JumpOver()
    }
    // 微信支付 切换回来 要
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  watch: {
    screenWidth: function (n, o) {
      if (n <= 1000) {
        this.ismobile = true
      } else {
        this.ismobile = false
      }
    },
    pageVerifyNum: function (news, olds) {
      if (news > 3) {
        this.frameRemindDialog = true
        // 结束定时器
        clearInterval(this.pageVerifyTimer)
      } else {
        this.pageRefresh = 0
        this.frameQuotationDialog = true
        this.orderVerify()
      }
    },
    language: function (newCur, oldCur) {
      this.writePayPageShow()
    },
    $route: function (to, from) {
      console.log(to, from)
    },
    paymentOn: function (to, form) {
      if (to === 'pingpong') {
        this.writePayPageShow()
      }
    }
  },
  methods: {
    showFacilities (orderData) {
      this.amenities = orderData.amenities
      this.promotions = orderData.promotions
      this.facilitiesDialogVisible = true
    },
    setCancellationColor (value) {
      if (value === '1' || value === 1) {
        return '#007f61'
      } else if (value === '2' || value === 2) {
        return '#d99c00'
      } else {
        return '#cc0000'
      }
    },
    getPermissions (value) {
      this.allPermissions = value
    },
    setCollapse (value) {
      this.isCollapse = value
      if (value === false) {
        this.contentWidth = document.body.clientWidth - 260
      } else {
        this.contentWidth = document.body.clientWidth - 74
      }
      this.personWidth = (this.contentWidth * 0.2182) - 10
    },
    formatCardNumber (e) {
      const input = e.target
      const cursorIndex = input.selectionStart
      const lineNumOfCursorLeft = (e.target.value.slice(0, cursorIndex).match(/\s/g) || []).length
      const noLine = e.target.value.replace(/\s/g, '')
      const newCardNum = noLine.replace(/\D+/g, '').replace(/(\d{4})/g, '$1 ').replace(/\s$/, '')
      const newLineNumOfCursorLeft = (newCardNum.slice(0, cursorIndex).match(/\s/g) || []).length
      const newCursorIndex = cursorIndex + newLineNumOfCursorLeft - lineNumOfCursorLeft
      this.$nextTick(() => {
        this.cardNo = newCardNum
        this.$nextTick(() => {
          input.selectionStart = newCursorIndex
          input.selectionEnd = newCursorIndex
        })
      })
    },
    hotelLanguage (language) {
      this.language = language
    },
    getfirstName (firstName) {
      this.firstName = firstName
    },
    checkSpecial () {
      this.special = this.special.replace(/[\u4e00-\u9fa5/]|[^a-zA-Z0-9\u4E00-\u9FA5\s+,.!-?:;()/]/g, '')
    },
    writePayPageShow: function () {
      this.orderShow = true
      var that = this
      let locationHref = window.document.location.href
      var orderno = this.$route.query.orderno
      var params = this.$route.params
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
        if (orderno === undefined) {
          orderno = params.orderno
        }
      }
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }

      this.hotelid = params.hotelid

      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var requestTime = parseInt(new Date().getTime())
      this.source = this.common.sourceSet()
      var sessionid = this.common.sessionidGet(this)
      // 订单信息填写数据
      var orderDataJson = {
        'token': token,
        'hotelid': params.hotelid,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums === undefined ? [] : params.childNums,
        'product': params.product,
        'time': time,
        'source': this.source,
        'orderno': orderno,
        'currency': currency,
        'paymentOn': this.paymentOn,
        'sessionid': sessionid,
        'language': this.language,
        'operation': 'writePayShow'
      }
      var orderDataShow = this.common.encryptionData(orderDataJson, this)
      writePayShow(orderDataShow).then(res => {
        if (res.flag === '110') {
          var regionSel = {'value_zh': this.orderData.roomName.zh, 'value_en': this.orderData.roomName.en, 'type_id': 1, 'type_data_id': params.hotelid}
          sessionStorage.setItem('regionSel', JSON.stringify(regionSel))
          this.searchjson['start_date'] = params.checkin
          this.searchjson['end_date'] = params.checkout
          this.searchjson['room'] = params.room
          this.searchjson['adult'] = params.adult
          this.searchjson['child'] = params.child
          this.searchjson['childNums'] = params.childNums
          this.searchjson['type'] = 3
          this.searchjson['type_id'] = params.hotelid
          this.searchjson['region'] = this.orderData.roomName.en
          this.searchjson['source'] = this.source
          this.$router.push({name: 'HotelList', query: this.searchjson})
        } else if (res.flag === '001') {
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          if (this.source !== '') {
            this.$router.push({name: 'login', query: {'source': this.source}})
          } else {
            this.$router.push({name: 'login'})
          }
        } else if (res.flag === '011') { // 积分支付.
          window.location.href = res.data.url
        } else if (res.flag === '012') {
          this.$router.push({name: 'tripDetail', query: { 'orderno': orderno, 'source': this.source }})
        } else {
          if (res.data.orderData.order_status !== 1 && res.data.orderData.order_status !== '1') {
            this.$router.push({name: 'tripDetail', query: { 'orderno': orderno, 'source': this.source }})
          }
          // 如果订单已经微信支付，需要跳转到订单结果页面
          if (res.data.orderData.wechat_pay_status === 1) {
            this.wechatJumpOver()
          }
          if (res.data.orderData.orderPayPageTime !== 0) {
            this.orderPayPageTime = res.data.orderData.orderPayPageTime
          }
          if (res.data.orderData.createtime !== 0) {
            var dateTime = (parseInt(new Date().getTime() / 1000) - res.data.orderData.createtime)
            if (dateTime <= this.orderPayPageTime) {
              this.remainTime = this.orderPayPageTime - dateTime
            } else {
              this.remainTime = 0
            }
            this.minute = Math.floor((this.remainTime / 60) % 60)
            this.second = Math.floor(this.remainTime % 60)
          }
          // 信息
          this.hotel = res.data.hotel
          this.loginStatus = res.data.orderData.loginStatus
          this.firstName = res.data.orderData.firstname
          this.lastName = res.data.orderData.lastname
          this.userEmail = res.data.orderData.useremail
          this.cancelData = res.data.orderData.cancelData.en
          this.telOptions = res.data.countryCode
          this.homeSurplus = res.data.orderData.remainrooms
          this.orderData = res.data.orderData
          this.special = res.data.orderData.special_request
          this.customInfo = res.data.orderData.custom_info
          this.canceltextZh = this.orderData.canceltext.zh
          this.canceltextEn = this.orderData.canceltext.en
          this.payment = res.data.payment
          if (res.data.payment.total.status === '0') {
            that.activeName = 'electronicPayment'
          }
          if (res.data.orderData.pay_way.length > 0) {
            this.paymentOn = res.data.orderData.pay_way
          }
          if (this.orderData.discount !== '' && this.orderData.discount !== '0' && this.orderData.discount !== 0) {
            this.isDiscount = true
            this.userCouponId = this.orderData.user_coupon_id
          } else {
            this.isDiscount = false
            this.userCouponId = ''
          }
          // 是否显示取消按钮.
          this.showCancel = res.data.orderData.order_status === '1' && (this.$route.query.showCancel === 1 || this.$route.query.showCancel === '1') ? '1' : '0'
          // pingpong 支付加载
          that.pingpongPaymentWrap()

          // pingpong 支付
          if (res.data.orderData.pingpong_pay_status !== 0 && res.data.orderData.pingpong_pay_status !== '0') {
            this.pingpongJumpOver()
          }
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(orderDataShow, res, requestTime, responseTime)
        })
      })
      this.orderShow = false
    },
    getLanguageHtml: function (data, type) {
      if (data === undefined) {
        return ''
      }
      var getLanguage = this.common.languageSet(this)
      if (['hotelname', 'hoteladdress'].includes(type)) {
        var typeLan = type + '_' + getLanguage
        return data[typeLan]
      } else if (['roomName', 'checkin', 'checkout', 'night', 'roomNum', 'person', 'child', 'bedType', 'breakfast', 'cancel', 'cancelData'].includes(type)) {
        if (getLanguage === 'zh') {
          return data.zh
        } else {
          return data.en
        }
      } else if (['userLastNameError', 'userNameError', 'emailError', 'telError', 'emailConfirmError', 'cardNoError', 'effectiveDateError', 'securityCodeError', 'emailError', 'telError', 'emailConfirmError', 'paymentLabel'].includes(type)) {
        return this.$t(data)
      } else if (['buttonMeansYouAgree'].includes(type)) {
        return this.$t(type)
      }
    },
    blurs (refInfo) {
      var refName = this.$refs[refInfo].value
      if (refName === '' || refName === null) {
        if (refInfo === 'userlastname1') {
          this.userLastNameError = 'pleaseLastName'
        }
        if (refInfo === 'username1') {
          this.userNameError = 'pleaseFirstName'
        }
        if (refInfo === 'emails') {
          this.emailError = 'pleaseEnterYourEmailOrYouMightMissBooking'
        }
        this.$set(this.someArray, refInfo, true)
      } else {
        var pattern = ''
        if (refInfo === 'userlastname1') {
          this.userLastNameError = ''
        }
        if (refInfo === 'username1') {
          this.userNameError = ''
        }
        if (refInfo === 'emails') {
          pattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
          if (!pattern.test(refName)) {
            this.emailError = 'pleaseValidEmailReservationConfirmationEmail'
            this.$set(this.someArray, refInfo, true)
          } else {
            this.$set(this.someArray, refInfo, false)
          }
        } else if (refInfo === 'tel1') {
          pattern = /^[0-9]*$/
          if (this.selectTel === '42') {
            pattern = /^1[0-9]{10}$/
          }
          if (!pattern.test(refName)) {
            this.$set(this.someArray, refInfo, true)
          } else {
            this.$set(this.someArray, refInfo, false)
          }
        } else {
          pattern = new RegExp('[A-Za-z]+')
          // 不支持单引号
          var pattern1 = new RegExp("[\u4E00-\u9FA5]|[0-9]|[`@.~!#$^&*()=|{}':;'/,\\[\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+_]")
          // 支持单引号
          // var pattern1 = new RegExp('[\u4E00-\u9FA5]|[0-9]|[`@.~!#$^&*()=|{}:;/,\\[\\]<>/?~！@#￥……&*（）——|{}【】‘；：”“。，、？%+_]')
          if (!pattern.test(refName) || pattern1.test(refName)) {
            if (refInfo === 'userlastname1') {
              this.userLastNameError = 'pleaseTextEnglish'
            }
            if (refInfo === 'username1') {
              this.userNameError = 'pleaseTextEnglish'
            }
            this.$set(this.someArray, refInfo, true)
          } else {
            this.$set(this.someArray, refInfo, false)
          }
        }
      }

      this.frameRiseDialog = false
    },
    getSomeThing (index) { // 返回数组元素
      return this.someArray[index]
    },
    showCardRemindInfo () {
      this.showCardRemind = true
    },
    showCardRemindInfoTwo () {
      this.showCardRemindTwo = true
    },
    JumpOver: function () {
      // 历史信息
      var params = this.$route.params
      var orderno = this.$route.query.orderno
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
        if (orderno === undefined) {
          orderno = params.orderno
        }
      }

      // 点击支付订单 后关闭下次点击
      if (this.payOrdernoClick === true) {
        // 如果微信PC支付 则 需要弹框
        if (this.paymentOn === 'wechat' && this.weChatImgUrl !== '') {
          this.wechatEject = true
        }
        return false
      }
      this.payOrdernoClick = true

      // 防止重复点击一分钟后 可以点击
      setTimeout(() => {
        this.payOrdernoClick = false
      }, 5000)

      this.showCardRemind = false
      this.showCardRemindTwo = false
      let locationHref = window.document.location.href

      if (this.common.isMobile() === true) {
        if (!['saveCard', 'newCard'].includes(this.paymentOn)) {
          this.activeName = 'electronicPayment'
        }
      }

      var securityCode = ''
      var cardno = ''
      var effectivedate = ''
      var securityCodeTwo = ''
      var username = ''
      if (['saveCard', 'newCard'].includes(this.activeName)) {
        if (this.activeName === 'saveCard') {
          this.$options.methods.blursCode.bind(this)('securityCode')
          if (this.securityCodeShow === true) {
            this.$refs['securityCode'].focus()
            return false
          }
          securityCode = this.$refs['securityCode'].value
        } else if (this.activeName === 'newCard') {
          this.$options.methods.blurs.bind(this)('username')
          let username = this.$options.methods.getSomeThing.bind(this)('username')
          if (username === true) {
            this.$refs['username'].focus()
            return false
          }
          this.$options.methods.blurs.bind(this)('cardno')
          let cardno = this.$options.methods.getSomeThing.bind(this)('cardno')
          if (cardno === true) {
            this.$refs['cardno'].focus()
            return false
          }
          this.$options.methods.blurs.bind(this)('effectivedate')
          let effectivedate = this.$options.methods.getSomeThing.bind(this)('effectivedate')
          if (effectivedate === true) {
            this.$refs['effectivedate'].focus()
            return false
          }
          this.$options.methods.blurs.bind(this)('securityCodeTwo')
          let securityCodeTwo = this.$options.methods.getSomeThing.bind(this)('securityCodeTwo')
          if (securityCodeTwo === true) {
            this.$refs['securityCodeTwo'].focus()
            return false
          }
        }

        // 支付信息
        if (this.activeName === 'newCard') {
          username = this.$refs['username'].value
          cardno = this.$refs['cardno'].value
          effectivedate = this.$refs['effectivedate'].value
          if (cardno.length >= 20) {
            this.$refs['cardno'].focus()
            return false
          }
          if (effectivedate.length >= 6) {
            this.$refs['effectivedate'].focus()
            return false
          }
        }
        securityCodeTwo = this.$refs['securityCodeTwo'].value
        if (securityCodeTwo.length >= 4) {
          this.$refs['securityCodeTwo'].focus()
          return false
        }
      }

      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      this.source = this.common.sourceSet()
      if (params.source !== this.source) {
        this.pageRefresh = 0
        this.frameQuotationDialog = true
        this.orderVerify()
      }
      this.checkIn = params.checkin
      this.checkOut = params.checkout
      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      // 订单信息填写数据
      var orderFinishBookJson = {
        'token': token,
        'activeName': this.activeName,
        'securityCode': securityCode,
        'username': username,
        'cardno': cardno,
        'effectivedate': effectivedate,
        'securityCodeTwo': securityCodeTwo,
        'paymentInfo': this.paymentCardno,
        'hotelid': params.hotelid,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums,
        'product': params.product,
        'source': params.source,
        'orderno': orderno,
        'rememberCard': this.checked.toString(),
        'currency': currency,
        'time': time,
        'paymentOn': this.paymentOn,
        'specialRequirements': this.special,
        'sessionid': sessionid,
        'operation': 'writePayFinishBook'
      }
      var orderFinishBook = this.common.encryptionData(orderFinishBookJson, this)
      // pingpong 支付 返回则直接跳转
      if (this.pingpongPayResult()) {
        // 点击完成 埋点记录
        this.clickPageAction('PayNow', '', {'orderno': orderno, 'payMethod': orderFinishBook.paymentOn}, orderFinishBook, {})
        return false
      }
      this.fullscreenLoading = true
      writePayFinishBook(orderFinishBook).then(res => {
        this.fullscreenLoading = false
        // 点击完成 埋点记录
        this.clickPageAction('PayNow', '', {'orderno': orderno}, orderFinishBook, res)

        if (res.flag === '110') {
          var regionSel = {'value_zh': this.orderData.roomName.zh, 'value_en': this.orderData.roomName.en, 'type_id': 1, 'type_data_id': params.hotelid}
          sessionStorage.setItem('regionSel', JSON.stringify(regionSel))
          this.searchjson['start_date'] = params.checkin
          this.searchjson['end_date'] = params.checkout
          this.searchjson['room'] = params.room
          this.searchjson['adult'] = params.adult
          this.searchjson['child'] = params.child
          this.searchjson['childNums'] = params.childNums
          this.searchjson['type'] = 3
          this.searchjson['type_id'] = params.hotelid
          this.searchjson['region'] = this.orderData.roomName.en
          this.searchjson['source'] = this.source
          this.$router.push({name: 'HotelList', query: this.searchjson})
        } else if (['155', '154', '153', '200'].includes(res.flag)) {
          // 无母房型有报价、至少有一个母房型有报价、涨价 显示取消订单按钮
          this.showCancel = '1'
        }
        if (res.flag === '001') {
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          if (this.source !== '') {
            this.$router.push({name: 'login', query: {'source': this.source}})
          } else {
            this.$router.push({name: 'login'})
          }
        } else if (['006', '007'].includes(res.flag)) { // 未支付、已支付直接跳转结果页.
          this.$router.push({name: 'PayCallbackResult', query: {'orderno': orderno}})
        } else if (res.flag === '005') {
          // 安全码错误
          this.securityCodeShow = true
          this.$refs['securityCode'].focus()
        } else if (res.flag === '010') {
          this.frameNoticePublicShowText = res.msg
          this.frameNoticePublicShow = true
        } else if (res.flag === '155') {
          // 无母房型有报价
          this.frameHotelSoldDialog = true
        } else if (res.flag === '154') {
          // 至少有一个母房型有报价
          this.frameHomeSoldDialog = true
        } else if (['153', '163', '173'].includes(res.flag)) {
          if (this.pageRefresh === 0 && res.data.time !== 0) {
            var dateTime = (parseInt(new Date().getTime() / 1000) - res.data.time)
            if (dateTime <= this.orderPayPageTime) {
              this.remainTime = this.orderPayPageTime - dateTime
            } else {
              this.remainTime = 0
            }
            this.minute = Math.floor((this.remainTime / 60) % 60)
            this.second = Math.floor(this.remainTime % 60)
            this.countDowm()
          }
          // 涨价
          this.frameRiseDialog = true
          this.risePrice = res.data.priceRise
        } else if (['171'].includes(res.flag)) {
          // 微信获取openid url
          window.location.href = res.data.openid_url
        } else if (res.flag === '401') {
          // 提醒额度不足
          this.frameNetworkDialog = true
        } else if (res.flag === '402') {
          this.frameNetworkDialog = true
        } else if (['159', '160', '158', '200'].includes(res.flag)) {
          if (this.activeName !== 'electronicPayment') {
            // 下单失败
            var orderResultData = {
              'hotelid': params.hotelid,
              'product': params.product,
              'checkin': params.checkin,
              'checkout': params.checkout,
              'room': params.room,
              'adult': params.adult,
              'child': params.child,
              'childNums': params.childNums,
              'source': params.source,
              'orderno': orderno,
              'flag': res.flag
            }
            localStorage.setItem('orderResultData', JSON.stringify(orderResultData))
            this.$router.push({name: 'PayResult', params: orderResultData})
          } else {
            var orderInfoData = {
              'hotelid': params.hotelid,
              'product': params.product,
              'checkin': params.checkin,
              'checkout': params.checkout,
              'room': params.room,
              'adult': params.adult,
              'child': params.child,
              'childNums': params.childNums,
              'source': params.source,
              'orderno': orderno,
              'paymentOn': this.paymentOn,
              'paymentSkipUrl': res.data.url
            }
            localStorage.setItem('orderData', JSON.stringify(orderInfoData))

            // wechat 区分与其他的支付
            if (this.paymentOn === 'wechat' && orderFinishBook.flag === 'mobile' && orderFinishBook.ua.indexOf('MicroMessenger') !== -1) { // 微信自带浏览器 支付
              this.frameRenewDialog = true
              // 微信js支付
              console.log('微信支付')
              console.log(res.data.payRequest)
              this.wxJsPay(res.data.payRequest)
            } else if (this.paymentOn === 'wechat' && orderFinishBook.flag === 'website') { // 微信PC 支付
              console.log('微信支付:' + res.data.url)
              this.wechatEject = true
              this.weChatImgUrl = res.data.url
            } else if (this.paymentOn === 'wechat' && orderFinishBook.flag === 'mobile') { // 微信h5 支付
              console.log('微信支付:' + res.data.url)
              this.frameRenewDialog = true
              this.wechatH5Polling()
              window.location.href = res.data.url
            } else if (this.paymentOn === 'credit') {
              // 额度支付，跳转结果页面
              this.$router.push({name: 'PayResult', params: orderInfoData})
            } else {
              this.$router.push({name: 'Waiting', params: orderInfoData})
            }
          }
        }
      })
    },
    // 微信手机支付 轮询 支付状态 跳转到回调页面
    wechatH5Polling: function () {
      var that = this
      var num = 0
      // 如果没有遮罩层 则添加遮罩层
      if (this.frameRenewDialog !== true) {
        this.frameRenewDialog = true
      }
      if (this.wechatH5Status !== '') {
        return false
      }

      // 1秒请求一次 10秒钟跳转结果页面
      this.wechatH5Status = setInterval(function () {
        // h5支付 大于20秒则跳转到支付结果页面
        if (num >= 10) {
          clearInterval(that.wechatH5Status)
          that.wechatH5Status = ''
          that.wechatJumpOver()
        }
        num++
        // 查询当前订单状态
        var params = that.$route.params
        var orderno = that.$route.query.orderno
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
          if (orderno !== undefined) {
            orderno = params.orderno
          }
        }

        var language = that.common.languageSet(that)
        var currency = that.common.currencySet(that)
        var time = parseInt(new Date().getTime() / 1000)
        var sessionid = that.common.sessionidGet(that)

        // 验证verify
        var token = that.$md5('0' + that.common.lfSignKey)
        if (localStorage.getItem('token')) {
          token = localStorage.getItem('token')
        }

        var payData = {
          'token': token,
          'hotelid': params.hotelid,
          'checkin': params.checkin,
          'checkout': params.checkout,
          'room': params.room,
          'adult': params.adult,
          'child': params.child,
          'childNums': params.childNums,
          'product': params.product,
          'source': params.source,
          'orderno': orderno,
          'language': language,
          'currency': currency,
          'sessionid': sessionid,
          'paymentOn': that.paymentOn,
          'operation': 'paymentOrderData',
          'time': time
        }
        var payDataJson = that.common.encryptionData(payData, that)
        orderPayment(payDataJson).then(res => {
          if (res.flag === '200') {
            if (res.data.payStatus === 'finish') {
              that.wechatJumpOver()
              clearInterval(that.wechatH5Status)
              that.wechatH5Status = ''
            }
          }
        })
      }, 2000)
    },
    // 微信支付 回调
    wechatJumpOver: function () {
      // 如果没有遮罩层 则添加遮罩层
      if (this.frameRenewDialog !== true) {
        this.frameRenewDialog = true
      }

      // 请求回调接口
      // {"PayerID":"4MBFCD7VEG7EQ","operation":"paymentCallback","payType":"paypal","roompaiOrderno":"YG033197116","time":"1680256566","token":"6BG53584KR1101907","user_token":"462f8cbd0db49354ab16d405d9af1256"}
      // 历史信息
      var params = this.$route.params
      var orderno = this.$route.query.orderno
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
        if (orderno !== undefined) {
          orderno = params.orderno
        }
      }
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }

      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      window.location.href = '/api/orderBook?operation=paymentCallback&payType=wechat&time=' + time + '&roompaiOrderno=' + orderno + '&source=' + params.source + '&user_token=' + token + '&sessionid=' + sessionid + '&environment=test'
    },
    // 微信js支付签名
    wechatJsSign: function () {
      var that = this

      var params = this.$route.params
      var orderno = this.$route.query.orderno
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
        if (orderno !== undefined) {
          orderno = params.orderno
        }
      }

      var time = parseInt(new Date().getTime() / 1000)
      var payData = {
        'url': window.location.href.split('#')[0],
        'orderno': orderno,
        'operation': 'wechatJsPayGetSign',
        'time': time
      }
      var payDataJson = this.common.encryptionData(payData, this)
      wechatJsPayGetSign(payDataJson).then(res => {
        const config = res.data
        that.wx.config({
          debug: false,
          appId: config.appId,
          timestamp: config.timestamp,
          nonceStr: config.nonceStr,
          signature: config.signature,
          jsApiList: ['chooseWXPay', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo']
        })
      })
    },
    // 微信js支付
    wxJsPay: function (payRequest) {
      var that = this
      this.wx.ready(function () {
        that.wx.chooseWXPay({
          appId: payRequest.appId,
          timestamp: payRequest.timeStamp,
          nonceStr: payRequest.nonceStr,
          package: payRequest.package,
          signType: payRequest.signType,
          paySign: payRequest.paySign,
          success: function (res) {
            // 支付成功的回调函数
            console.log('-------成功------')
            that.wechatJumpOver()
          },
          fail: function (res) {
            // 支付失败的回调函数
            console.log('-------失败------')
            that.wechatJumpOver()
          },
          cancel: function (res) {
            // 用户取消支付的回调函数
            console.log('------取消-------')
            that.frameRenewDialog = false
          }
        })
      })
    },
    // pingpong 支付结果
    pingpongJumpOver: function () {
      var pingpongPayStatus = this.orderData.pingpong_pay_status
      // 等待页面 轮询结果
      if (pingpongPayStatus === 1) {
        this.fullscreenLoading = true
        // 轮询结果
        this.pingpongPolling()
        return false
      }

      // 失败 需要特殊弹框
      if (pingpongPayStatus === 3) {
        // 如果非订单详情页  点击进入支付页
        if (this.showCancel !== '1' && this.showCancel !== 1) {
          this.framePaymentFailDialog = true
        }
        return false
      }

      // 支付成功 请求回调接口
      // 历史信息
      var source = this.$route.query.source
      var orderno = this.$route.query.orderno

      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }

      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      window.location.href = '/api/orderBook?operation=paymentCallback&payType=pingpong&time=' + time + '&roompaiOrderno=' + orderno + '&source=' + source + '&user_token=' + token + '&sessionid=' + sessionid + '&environment=pingpong'
    },
    orderVerify: function () {
      // 请求验价数据
      let locationHref = window.document.location.href
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var params = this.$route.params
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
      }

      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var requestTime = parseInt(new Date().getTime())
      var sessionid = this.common.sessionidGet(this)

      var verifyJson = {
        'hotelid': params.hotelid,
        'product': params.product,
        'token': token,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'currency': currency,
        'source': this.source,
        'pageRefresh': this.pageRefresh,
        'sessionid': sessionid,
        'operation': 'orderBookVerify',
        'time': time
      }
      var verifyData = this.common.encryptionData(verifyJson, this)
      orderBookVerify(verifyData).then(res => {
        this.frameQuotationDialog = false
        if (res.flag === '001') {
          // 未登录
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          if (this.source !== '') {
            this.$router.push({name: 'login', query: {'source': this.source}})
          } else {
            this.$router.push({name: 'login'})
          }
        } else if (res.flag === '155') {
          // 无母房型有报价
          this.frameHotelSoldDialog = true
        } else if (res.flag === '154') {
          // 至少有一个母房型有报价
          this.frameHomeSoldDialog = true
        } else if (['153', '200'].includes(res.flag)) {
          if (this.pageRefresh === 0 && res.data.time !== 0) {
            var dateTime = (parseInt(new Date().getTime() / 1000) - res.data.time)
            if (dateTime <= this.orderWritePageTime) {
              this.remainTime = this.orderWritePageTime - dateTime
            } else {
              this.remainTime = 0
            }
            this.minute = Math.floor((this.remainTime / 60) % 60)
            this.second = Math.floor(this.remainTime % 60)
            this.countDowm()
          }

          if (res.flag === '153') {
            // 涨价
            this.frameRiseDialog = true
            this.risePrice = res.data.priceRise
          } else if (res.flag === '200') {
            // 成功
            // location.reload()
          }
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(verifyData, res, requestTime, responseTime, 'confirmPrice')
        })
      })
    },
    continueBookingFun: function (val) {
      // 继续预订 记录埋点
      this.clickPageAction('continue_order', '', {})

      this.frameRemindDialog = false
      this.pageRefresh = 0
      this.frameQuotationDialog = true
      this.orderVerify()
    },
    frameRiseBookingBackFun: function (val) {
      this.frameRiseDialog = false
      this.pageRefresh = 0
    },
    frameRiseBookingFun: function (val) {
      this.frameRiseDialog = false
      this.pageRefresh = 0
      this.jumpPayOrderPage()
    },
    frameChangeRoomBookingBackFun: function (val) {
      this.frameChangeRoomDialog = false
      this.pageRefresh = 0
    },
    frameChangeRoomBookingFun: function (val) {
      this.frameChangeRoomDialog = false
      this.pageRefresh = 0
      this.JumpOver()
    },
    frameChangePriceAndRoomBookingBackFun: function (val) {
      this.frameChangePriceAndRoomDialog = false
      this.pageRefresh = 0
    },
    frameChangePriceAndRoomBookingFun: function (val) {
      this.frameChangePriceAndRoomDialog = false
      this.pageRefresh = 0
      this.JumpOver()
    },
    // 网络中断请重试
    frameNoticeFun: function (val) {
      this.JumpOver()
    },
    frameNoticePublicFun: function (val) {
      this.frameNoticePublicShow = false
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    countDowm () {
      var self = this
      clearInterval(this.promiseTimer)
      this.promiseTimer = setInterval(function () {
        if (self.minute !== 0 && self.second === 0) {
          self.second = 59
          self.minute -= 1
        } else if (self.minute === 0 && self.second === 0) {
          self.second = 0
          self.$emit('countDowmEnd', true)
          clearInterval(self.promiseTimer)
          self.pageVerifyNum++
          // self.frameRiseDialog = true
        } else {
          self.second -= 1
        }
      }, 1000)
    },
    formatNum (num) {
      return num < 10 ? '0' + num : '' + num
    },
    refresh () {
      location.reload()
      this.frameDialog = false
      this.frameRiseDialog = false
    },
    reserve () {
      this.frameRiseDialog = false
      this.frameDialog = true
    },
    login () {
      // 其他客户
      var userOtherInfo = []
      for (let index = 2; index <= this.guestRoomNum; index++) {
        var userlastnameR = this.$refs['userlastname' + index][0].value
        var usernameR = this.$refs['username' + index][0].value
        var nationalityR = this.selectNat[index]
        var userOtherR = {'userlastname': userlastnameR, 'username': usernameR, 'nationality': nationalityR}
        userOtherInfo.push(userOtherR)
      }

      // 获取用户填写信息
      var userlastname1 = this.$refs['userlastname1'].value
      var username1 = this.$refs['username1'].value
      var emails = this.$refs['emails'].value
      var tel1 = this.$refs['tel1'].value
      var specialRequirements = this.$refs['specialRequirements'].value

      // 用户订单数据 存入 localStorage
      var orderUserData = {
        'roomHost': {'userlastname': userlastname1, 'username': username1, 'emails': emails, 'tel': tel1, 'specialRequirements': specialRequirements, 'areaCode': this.selectTel, 'nationality': this.selectNat[1]},
        'roomOther': userOtherInfo
      }
      sessionStorage.setItem('orderUserData', JSON.stringify(orderUserData))

      let locationHref = window.document.location.href
      sessionStorage.setItem('LoginWebsiteAddress', locationHref)
      if (this.source !== '') {
        this.$router.push({name: 'login', query: {'source': this.source}})
      } else {
        this.$router.push({name: 'login'})
      }
    },
    loginOut: function () {
      // 判断用户是否登录 获取用户信息
      var token = localStorage.getItem('token')
      if (token !== undefined && token !== '') {
        var time = parseInt(new Date().getTime() / 1000)
        var dataJson = {'token': token, 'operation': 'loginOut', 'time': time}
        var data = this.common.encryptionData(dataJson, this)
        signIn(data).then(res => {
          if (res.flag === '200') {
            this.loginStatus = false
            localStorage.removeItem('token')
            // localStorage.removeItem('getCookie')
            localStorage.removeItem('sessionid')
            localStorage.removeItem('LoginWebsiteAddress')
            location.reload()
          }
        })
      }
    },
    getPolicyDia (val) {
      this.policyDialog = val
    },
    getClauseDia (val) {
      this.clauseDialog = val
    },
    linkClick (type, click = '1') {
      // 点击 记录埋点
      if (type === 'clause') {
        if (click === '2') {
          this.clauseDialog = true
        }
        this.clickPageAction('writePayment_terms_use', '', {})
      } else if (type === 'policy') {
        if (click === '2') {
          this.policyDialog = true
        }
        this.clickPageAction('writePayment_privacy_policy', '', {})
      }
    },
    pingpongPaymentWrap: function () {
      if (this.orderData.pay_way !== 'pingpong') {
        return false
      }
      // v2 版本
      this.pingpongAccessToken = this.orderData.pay_url
      window.PingPong.Checkout.customizeStyles = {
        themeType: 'light',
        themeColor: 'rgb(54, 175, 3)',
        themeColorLight: 'rgba(54, 175, 3, 0.4)'
      }
      window.PingPong.Checkout.customizeConfig = {
        originalPay: false // 不使用默认的 PingPong 支付按钮
      }
      // 滚动到pingpong loading
      this.$nextTick(() => {
        const element = document.querySelector('#paymentTypeTop')
        if (element) {
          element.scrollIntoView({behavior: 'smooth'})
        }
      })
    },
    pingpongPayResult: function () {
      // 如果是pingpong 则调用对方方法 对方跳转我们的支付结果页面
      if (this.paymentOn === 'pingpong') {
        this.fullscreenLoading = true
        window.PingPong.Checkout.pay.run()
        this.pingpongPolling()
        return true
      }

      return false
    },
    pingpongPolling: function () {
      var that = this
      var num = 0

      if (this.pingpongStatus !== '') {
        return false
      }

      // 2秒请求一次 60秒钟跳转结果页面
      this.pingpongStatus = setInterval(function () {
        // pingpong支付 大于60秒则跳转到支付结果页面
        if (num >= 20) {
          clearInterval(that.pingpongStatus)
          that.pingpongStatus = ''
          // that.pingpongJumpOver()
          window.location.reload()
        }
        num++

        // 查询当前订单状态
        var params = that.$route.params
        var orderno = that.$route.query.orderno
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
          if (orderno === undefined) {
            orderno = params.orderno
          }
        }

        var language = that.common.languageSet(that)
        var currency = that.common.currencySet(that)
        var time = parseInt(new Date().getTime() / 1000)
        var sessionid = that.common.sessionidGet(that)

        // 验证verify
        var token = that.$md5('0' + that.common.lfSignKey)
        if (localStorage.getItem('token')) {
          token = localStorage.getItem('token')
        }

        var payData = {
          'token': token,
          'hotelid': params.hotelid,
          'checkin': params.checkin,
          'checkout': params.checkout,
          'room': params.room,
          'adult': params.adult,
          'child': params.child,
          'childNums': params.childNums !== undefined ? params.childNums : '',
          'product': params.product,
          'source': params.source,
          'orderno': orderno,
          'language': language,
          'currency': currency,
          'sessionid': sessionid,
          'paymentOn': that.paymentOn,
          'operation': 'paymentOrderData',
          'time': time
        }
        var payDataJson = that.common.encryptionData(payData, that)
        orderPayment(payDataJson).then(res => {
          if (res.flag === '200') {
            if (res.data.payStatus === 'finish' || res.data.payStatus === 'SUCCESS') {
              clearInterval(that.pingpongStatus)
              that.pingpongStatus = ''
              // 加载
              window.location.reload()
            } else if (res.data.payStatus === 'FAILED') {
              clearInterval(that.pingpongStatus)
              that.pingpongStatus = ''
              that.fullscreenLoading = false

              if (that.framePaymentFailDialog === false) {
                that.framePaymentFailDialog = true
              }
            } else if (res.data.payStatus === 'not') {
              clearInterval(that.pingpongStatus)
              that.pingpongStatus = ''
              that.fullscreenLoading = false
            }
          }
        })
      }, 3000)
    },
    paymentRetryClick: function () {
      this.framePaymentFailDialog = false
    }
  },
  computed: {
    formattedSpecialInstructions () {
      if (!this.hotelPolicyData.special_instructions_en) {
        return ''
      }
      const sentences = this.hotelPolicyData.special_instructions_en.split('.').filter(sentence => sentence.trim() !== '')
      const listItems = sentences.map(sentence => `<li>${sentence.trim()}.</li>`).join('')
      return `<ul>${listItems}</ul>`
    },
    minuteString () {
      return this.formatNum(this.minute)
    },
    secondString () {
      return this.formatNum(this.second)
    }
  }
}
</script>

<style scoped>
/* 左侧 menu*/
.el-main{text-align: left;}
.main{width:100%;}

/* 搜索条件 开始 */
.list-content{ color: #333; font-size: 14px;}
.avgprice{ color: #616161; font-size: 12px; line-height: 12px;margin-top: -10px;}
/* 详情 */
/deep/ .el-collapse-item__header, .el-collapse, /deep/ .el-collapse-item__wrap{border: none; background-color: #f8f9fa;}
.list-content /deep/ .el-collapse-item__arrow{ display: none;}
.back-button{height: 20px;line-height: 20px;}
.back-img{width: 15px; height: 15px; margin: 2.5px; float: left;}
.hotel-info{background-color: #FFF; margin-top: 15px; padding:20px 1.5% 10px 1.5%;border-radius: 5px;}
.hotel-name{height: 40px; line-height: 40px; color:rgb(83, 102, 163); font-size: 14px;}
.order-info{font-size: 12px; height: auto; line-height: 30px; clear: both;}
.oneline{clear: both; min-height: 40px; line-height: 40px;}
.price-oneline{clear: both; min-height: 48px; line-height: 48px;}
.oneline span{display: inline-block;}
.left-info{ width: 30%;font-size: 14px; font-weight: 500; float: left;}
.right-info{width: 70%; float: left;font-size: 14px;}
.quarter-row-title,
.quarter-row{
  display: grid;
  font-size: 14px;
  line-height: 40px;
  height: 40px;
  grid-template-columns: repeat(3, 1fr);
}
.quarter-row-title {
  background: #D9D9D940;
  font-weight: 500;
}
.quarter-row {
  font-weight: 400;
}
.quarter-col {
  text-align: left;
  color: #333;
  padding-left: 20px;
}
.points-txt {
  margin-top: 6px;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #86909C;
}
/* 客户信息 */
.hotel-line .msg-username{width:30%;display:inline-block;}
/deep/ .el-range-editor.is-active, /deep/ .el-range-editor.is-active:hover, /deep/ .el-select .el-input.is-focus .el-input__inner, /deep/ .el-input.is-active .el-input__inner, /deep/ .el-input__inner:focus{border-color: rgb(220, 135, 107);}
.hotel-line /deep/ .el-input__inner{border: 1px solid #DCDFE6;}
/deep/ .el-radio__input{margin-bottom: 15px;}

/* 支付方式 */
.payment-text{font-size: 13px; font-weight: 500; color: #333;vertical-align: text-bottom; margin-bottom: 10px;display: inline-block;}

/deep/ .el-radio__input.is-checked .el-radio__inner{border-color:rgba(83, 102, 163, 1);background:rgba(83, 102, 163, 1);}
/deep/ .el-radio__input.is-focus .el-radio__inner, /deep/ .el-radio__input .el-radio__inner:hover{border-color:rgba(83, 102, 163, 1);}

/* 特殊要求 */
.specialText{height: 80px; /* line-height: 80px; */ font-size: 14px;padding: 0px;border:none;}
.specialText /deep/ textarea{height:100%;resize:none;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;color: #333;}
/deep/ .el-textarea__inner:focus{border-color:rgb(83, 102, 163, 1);}

.hotel-policies-container {
  display: flex;
  flex-wrap: wrap;
  margin: 15px 0px;
  background: #fff;
  padding: 10px 1.5% 0px;
  border-radius: 5px;
}

.policy-block {
  width: 49%;
  margin: 10px 10px 20px 0px;
}

.policy-block h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
}

.policy-block .policy-content {
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
}

.check-info-container {
  display: flex;
  justify-content: space-between;
}

.check-info-block {
  width: 48%;
}

.check-info-title {
  color: #4E7997;
  font-size: 14px;
  margin-bottom: 10px;
}

.check-info-content p {
  margin: 8px 0;
  line-height: 1.5;
}

.policy-block .policy-content p {
  margin: 5px 0;
}

.policy-block .policy-content ul {
  margin: 5px 0;
  padding-left: 20px;
}

.price-details {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 20px;
}

.price-details-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  color: #666;
}

.package-tag {
  background: #F6FFED;
  color: #52C41A;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  border: 1px solid #B7EB8F
}

.price-sections-container {
  display: flex;
  gap: 29px;
  margin-bottom: 20px;
  align-items: stretch;
}

.price-section {
  flex: 1;
  background: #5366A30F;
  border-radius: 8px;
  padding: 16px 20px;
  display: flex; /* 新增：使内部元素可以使用flex布局 */
  flex-direction: column; /* 新增：使内部元素垂直排列 */
}

.price-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
}

.section-title {
  color: #5366A3;
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: 700;
}

.price-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1; /* 新增：使其填充可用空间，并将totals推到底部 */
}

.price-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.green-text {
    color: #2F7000;
}

.divider {
  height: 1px;
  background: #000000;
  margin-top: auto; /* 新增：将分隔线和总计部分推向底部 */
}

.price-item.total {
  font-weight: 600;
}

.total-price {
  display: flex;
  justify-content: justify;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid #e8e8e8;
  font-size: 16px;
  font-weight: 600;
}

.total-price .amount {
  color: #2b3481;
  font-size: 20px;
  margin-left: 5px;
}

.container {
    margin-top: 15px;
    background-color: #ffffff;
    padding: 15px 1%;
    border-radius: 4px;
    line-height: 1.5;
}

.container h1 {
    text-align: left;
    color: rgb(83, 102, 163);
    font-size: 16px;
    font-weight: 600;
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
}

/* 政策列布局 */
.policy-columns {
    display: flex;
    /* 允许列在需要时换行，虽然对于两列来说不那么关键 */
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;
}

.policy-column {
    flex: 1 1 45%;
    min-width: 300px; /* 确保在小屏幕下换行前有一个最小宽度 */
}

/* CSS规则：用于隐藏空的列 (这需要通过 JS 或模板逻辑来添加 `.empty` 类) */
.policy-column.empty {
    display: none; /* 如果列为空，则完全隐藏该列 */
}

/* 政策模块样式 */
.policy-module {
    background-color: #ffffff;
    border-radius: 4px;
    padding: 15px 20px;
    margin-bottom: 20px;
}

/* 移除每列中最后一个模块的底部外边距，使布局更紧凑 */
.policy-module:last-child {
    margin-bottom: 0;
}

.policy-module h2 {
    color: #333;
    font-size: 14px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e0e0e0;
    padding-left: 0;
}

/deep/ .policy-module ul {
    list-style: none;
    padding-left: 0;
    margin: 0;
}

/deep/ .policy-module li {
    position: relative;
    margin-bottom: 8px;
    padding-left: 0; /* 如果不使用自定义项目符号，则无需内边距 */
    font-size: 13px;
    color: #555;
}

.policy-module-text {
    position: relative;
    margin-bottom: 8px; /* Adjusted: Slightly reduced list item spacing */
    padding-left: 0; /* Adjusted: Removed padding for custom bullet if not needed */
    font-size: 13px; /* Adjusted: Slightly smaller font size */
    color: #555;
}

.policy-module div {
  font-size: 14px;
}

.policy-content >>> li {
  list-style-type: disc;
  margin-left: 20px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .policy-columns {
        flex-direction: column;
        gap: 20px;
    }
    .policy-column {
        min-width: 100%;
    }
    .policy-module {
        padding: 15px; /* Adjust padding for smaller screens if needed */
    }
}

/* 取消政策弹框样式 */
.cancel-policy {
  background: #fff;
  padding: 12px;
  /* max-height: 150px; */
  overflow-y: auto;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.content-item {
  display: flex;
  align-items: flex-start;
  background: #fff;
}

.cancel-policy .title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.cancel-policy .circle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 2px solid #cc0000; /* 修改为边框 */
  background: transparent; /* 背景设置为透明 */
  margin-top: 6px;
  margin-right: 8px;
  flex-shrink: 0;
}

.cancel-policy .text-content {
  flex: 1;
}

.cancel-policy .subtitle {
  font-size: 13px;
  color: #333;
  margin-bottom: 4px;
  font-weight: 500;
}

.cancel-policy .description {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

/* 弹框容器样式 */
.nonFefundable {
  background: #fff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-height: 180px !important;
  height: auto !important;
}

/deep/ .el-dialog {
  margin-top: 30vh !important;
}

/deep/ .facilities-dialog .el-dialog__body{
  padding: 0px 20px 30px;
}

.facilities-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.facilities-list li {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;
}

.facilities-list li i {
  font-size: 18px;
  margin-right: 10px;
  color: #6c5ce7;
}

.dialog-footer .el-button {
  border-radius: 5px;
}

/* You might need to adjust icon colors if they don't match exactly */
.facilities-list li .el-icon-present,
.facilities-list li .el-icon-time,
.facilities-list li .el-icon-magic-stick {
    color: #20c997;
}

.facilities-divider {
    width: 100%;
    height: 1px;
    background: #e5e6eb;
    margin-bottom: 15px;
    border: none;
  }

.arrow-icon {
  margin-right: 10px; /* 箭头与文字的间距 */
  color: #5366a3; /* 箭头颜色，可以根据品牌色调整 */
  font-size: 0.9em; /* 调整箭头大小 */
}
</style>
<style>
.el-drawer__open .el-drawer.btt{height:auto !important;}
.el-tooltip__popper.is-light {
  max-width: 300px !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  line-height: 1.5 !important;
  padding: 8px 12px !important;
  background: #999999 !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/order/WritePay.vue